module.exports = __webpack_public_path__ + "img/icon-a-3.346d0bd8.svg";